module.exports = __webpack_public_path__ + "static/img/bg-en.46ab6d94.png";